import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Col,
         DropdownButton,
         FormControl,
         FormGroup,
         Grid,
         MenuItem,
         Row } from 'react-bootstrap';
import store from 'store';

// imports for date picker
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';

import Config from './Config';
import { parseDate, parseDay, parseMonth, parseYear } from '../utils/Utils';



const logo = require('../assets/img/logo.png');
const iconUser = require('../assets/img/icon_user.png');

class ResultList extends Component {

    constructor(props, context) {
      super(props, context);

      this.handleSearchChange = this.handleSearchChange.bind(this);
      this.handleStartDateChange = this.handleStartDateChange.bind(this);
      this.handleEndDateChange = this.handleEndDateChange.bind(this);

      this.state = {

        firstName: '',
        lastName: '',
        // search filter
        searchQuery: '',

        // date filter
        startDate: undefined,
        endDate: undefined,

        // hospital filter
        hospitalList: [{description: 'All hospitals', ID: 99999, active: true}],
        selectedHospitalId: 99999,
        selectedHospitalTitle: 'All hospitals',

        // lab test type filter
        labList: [{description: 'All tests', Code: 99999, active: true}],
        selectedLabId: 99999,
        selectedLabTitle: 'All tests',

        // status filter
        statusList: [{keyDescription: 'All statuses', KeyCode: 99999, active: true}],
        selectedStatusId: 99999,
        selectedStatusTitle: 'All statuses',

      };
    }

    componentDidMount() {


      const token = store.get(Config.TOKEN);
      console.log('token', token);


      // Get result list
      const resultListUrl = `${Config.SERVER_URL}${Config.API_TESTCASE_LIST}?token=${token}`;
      fetch(resultListUrl, {
            method: 'POST'
      })
      .then((response) => response.json())
      .then((responseJson) => {
          console.log('API_TESTCASE_LIST, response = ', responseJson);
          this.setState({ labResults: responseJson.TestCaseTransList, filteredResults: responseJson.TestCaseTransList });
      })
      .catch((error) => {
          console.error(error);
      });

      // Get hospital filter list
      const hospitalFilterUrl = `${Config.SERVER_URL}${Config.API_HOSPITAL_FILTER}?token=${token}`;
      fetch(hospitalFilterUrl, {
            method: 'GET'
      })
      .then((response) => response.json())
      .then((responseJson) => {
          console.log('hospitalFilter', responseJson);
          const hospitals = responseJson.map(hospital => { return {...hospital, active: false} });
          this.setState({ hospitalList: [...this.state.hospitalList, ...hospitals] });
      })
      .catch((error) => {
          console.error(error);
      });



      // Get member name
      const profileUrl = `${Config.SERVER_URL}${Config.API_MEMBER_PROFILE}?token=${token}`;
      fetch(profileUrl, {
            method: 'POST'
      })
      .then((response) => response.json())
      .then((responseJson) => {
          console.log('member profile', responseJson);
          this.setState({ firstName: responseJson.fname, lastName: responseJson.lname });
      })
      .catch((error) => {
          console.error(error);
      });


      // Get lab test type filter list
      const labTestTypeFilterUrl = `${Config.SERVER_URL}${Config.API_LAB_TEST_TYPE}`;
      fetch(labTestTypeFilterUrl, {
            method: 'GET'
      })
      .then((response) => response.json())
      .then((responseJson) => {
          console.log(' Get lab test type filter list', responseJson);
          const labs = responseJson.map(lab => { return {...lab, active: false} });
          this.setState({ labList: [...this.state.labList, ...labs]} );

      })
      .catch((error) => {
          console.error(error);
      });

      // Get status list
      const statusFilterUrl = `${Config.SERVER_URL}${Config.API_TESTPROCESS_STATUS_LIST}`;

      console.log('statusFilterUrl', statusFilterUrl);
      fetch(statusFilterUrl, {
            method: 'GET'
      })
      .then((response) => response.json())
      .then((responseJson) => {
          console.log(' Get status filter list', responseJson);
          const statuses = responseJson.map(status => { return {...status, active: false} });
          this.setState({ statusList: [...this.state.statusList, ...statuses]} );

      })
      .catch((error) => {
          console.error(error);
      });
    }

    handleLogout(event){
      console.log('logging out ...');
      store.remove(Config.TOKEN);
      this.props.history.push({
        pathname: '/'
      });
    }

    handleStartDateChange(startDate) {
      this.applyFilter({startDate});
    }

    handleEndDateChange(endDate) {
      this.applyFilter({endDate});
    }

    handleSearchChange(event) {
      const searchQuery = event.target.value
      this.applyFilter({searchQuery});
    }

    handleTableClick(labResult, event) {
      this.props.history.push({
        pathname: '/resultSummary',
        state: { labResult }
      });
      store.set(Config.RESULT_ID, labResult.ID);
    }

    handleHospitalSelect(eventKey) {
      const selectedHospital = eventKey;
      this.applyFilter({ selectedHospitalId: selectedHospital.ID, selectedHospitalTitle: selectedHospital.description });
    }

    handleLabSelect(eventKey) {
      const selectedLab = eventKey;
      this.applyFilter({ selectedLabId: selectedLab.Code, selectedLabTitle: selectedLab.description });
    }

    handleStatusSelect(eventKey) {
      const selectedStatus = eventKey;
      this.applyFilter({ selectedStatusId: selectedStatus.KeyCode, selectedStatusTitle: selectedStatus.keyDescription });
    }

    onKeyPress(event) {
        if (event.which === 13 /* Enter */) {
          event.preventDefault();
        }
    }

    applyFilter({startDate=this.state.startDate,
                 endDate=this.state.endDate,
                 searchQuery=this.state.searchQuery,
                 selectedHospitalId=this.state.selectedHospitalId,
                 selectedHospitalTitle=this.state.selectedHospitalTitle,
                 selectedLabId=this.state.selectedLabId,
                 selectedLabTitle=this.state.selectedLabTitle,
                 selectedStatusId=this.state.selectedStatusId,
                 selectedStatusTitle=this.state.selectedStatusTitle
               } = {}) {
      let filteredResults = this.state.labResults.filter(labResult => labResult.PatientName.includes(searchQuery));

      //filter by selected lab test type
      if(selectedLabId !== undefined && selectedLabId !== 99999) {
        filteredResults = filteredResults.filter(labResult => labResult.TestTypeCode === selectedLabId)
      }

      //filter by selected hospital
      if(selectedHospitalId !== undefined && selectedHospitalId !== 99999) {
        filteredResults = filteredResults.filter(labResult => labResult.HospitalID === selectedHospitalId)
      }

      //filter by selected status
      if(selectedStatusId !== undefined && selectedStatusId !== 99999) {
        filteredResults = filteredResults.filter(labResult => labResult.ProcessKeyCode === selectedStatusId)
      }

      //filter by start date
      filteredResults = filteredResults.filter(labResult => {
        const startDateForFilter = startDate ? startDate : moment().year(0);
        if(labResult.getSampleDate){
          const getSampleMoment = moment(`${parseYear(labResult.getSampleDate)}-${parseMonth(labResult.getSampleDate)}-${parseDay(labResult.getSampleDate)}`);
          return getSampleMoment.isSameOrAfter(startDateForFilter);
        }
        return true
      });

      //filter by end date
      filteredResults = filteredResults.filter(labResult => {
        const endDateForFilter = endDate ? endDate : moment().year(9999);
        if(labResult.getSampleDate){
          const getSampleMoment = moment(`${parseYear(labResult.getSampleDate)}-${parseMonth(labResult.getSampleDate)}-${parseDay(labResult.getSampleDate)}`);
          return getSampleMoment.isSameOrBefore(endDateForFilter);
        }
        return true
      });

      console.log('applyFilter, filteredResults = ', filteredResults);
      this.setState({ filteredResults, startDate, endDate, searchQuery, selectedHospitalId, selectedHospitalTitle, selectedLabId, selectedLabTitle, selectedStatusId, selectedStatusTitle});
    }

    renderResultRow() {
      return this.state.filteredResults ? this.state.filteredResults.map(labResult =>
                  <tr role="button" key={labResult.ID} onClick={(event) => this.handleTableClick(labResult, event)}>
                    <td scope="row">{labResult.CaseNo ? labResult.CaseNo : null}</td>
                    <td scope="row">{labResult.HN ? labResult.HN : null}</td>
                    <td scope="row">{labResult.PatientName ? labResult.PatientName : null}</td>
                    <td>{labResult.LabName ? labResult.LabName : null}</td>
                    <td>{labResult.HospitalName ? labResult.HospitalName : null}</td>
                    <td>{labResult.getSampleDate ? parseDate(labResult.getSampleDate) : null}</td>
                    <td>
                      <Row>
                        <span className="status-name">{labResult.ProcessKeyDesc ? labResult.ProcessKeyDesc : null}</span>
                        {this.renderStatusLight(labResult.PaymentStatusCode)}
                      </Row>
                    </td>
                  </tr>
                ) : null

    }

    renderStatusLight(paymentStatusCode) {
        if (paymentStatusCode === '1UNPAID') {
            return (
                <span className="payment-status-badge-in-table">
                  <svg height="12" width="12">
                    <circle cx="6" cy="6" r="6" fill="red" />
                  </svg>
                  <span className="payment-status-name">Unpaid</span>
                </span>
            );
        } else if (paymentStatusCode === '2PENDING') {
            return (
                <span className="payment-status-badge-in-table">
                  <svg height="12" width="12">
                    <circle cx="6" cy="6" r="6" fill="orange" />
                  </svg>
                  <span className="payment-status-name">Pending</span>
                </span>
            );
        } else if (paymentStatusCode === '3PAID') {
            return (
                <span className="payment-status-badge-in-table">
                  <svg height="12" width="12">
                    <circle cx="6" cy="6" r="6" fill="green" />
                  </svg>
                  <span className="payment-status-name">Paid</span>
                </span>
            );
        }
    }

    render() {

      if(!store.get(Config.TOKEN)) {
        return <Redirect to='/' />;
      }

      console.log('ResultList state in render()', this.state);
        return (
            <Grid fluid>
              <Row className="genode-header">
                <Col xs={2}>
                  <img src={logo} className="App-logo" alt="logo" />
                </Col>
                <Col xs={2} xsOffset={8}>
                  <Row>
                    <img src={iconUser} className="icon-user" alt="User icon" /><span className="App-title">{`${this.state.firstName} ${this.state.lastName}`}</span>
                  </Row>
                  <Row>
                    <span className="text-logout" onClick={(event) => this.handleLogout(event)}>Logout</span>
                  </Row>
                </Col>
              </Row>

              <br/>

              <div>
                Filters
              </div>

              <Row className='filter-row'>
                <Col xs={10}>
                  &nbsp;
                  &nbsp;

                  <div style={{ display:'inline-block'}}>
                    <DatePicker
                      selected={this.state.startDate}
                      selectsStart
                      startDate={this.state.startDate}
                      endDate={this.state.endDate}
                      onChange={this.handleStartDateChange}
                      className="form-control"
                      placeholderText="Start date..."
                    />
                  </div>

                  &nbsp;

                  <div style={{ display:'inline-block'}}>
                    <DatePicker
                      selected={this.state.endDate}
                      selectsEnd
                      startDate={this.state.startDate}
                      endDate={this.state.endDate}
                      onChange={this.handleEndDateChange}
                      className="form-control"
                      placeholderText="End date..."
                    />
                  </div>

                  &nbsp;
                  &nbsp;
                  &nbsp;

                  <DropdownButton
                    className='dropdown-button'
                    bsStyle={'default'}
                    title={this.state.selectedLabTitle}
                    id={`LabFilter`}
                    onSelect={(eventKey) => this.handleLabSelect(eventKey)}
                  >
                    {this.state.labList ? this.state.labList.map(lab => <MenuItem eventKey={lab} key={lab.Code}>{lab.description}</MenuItem>) : null}
                  </DropdownButton>

                  <DropdownButton
                    className='dropdown-button'
                    bsStyle={'default'}
                    title={this.state.selectedHospitalTitle}
                    id={`HospitalFilter`}
                    onSelect={(eventKey) => this.handleHospitalSelect(eventKey)}
                  >
                    {this.state.hospitalList ? this.state.hospitalList.map(hospitalItem => <MenuItem eventKey={hospitalItem} key={hospitalItem.ID}>{hospitalItem.description}</MenuItem>) : null}
                  </DropdownButton>

                  <DropdownButton
                    className='dropdown-button'
                    bsStyle={'default'}
                    title={this.state.selectedStatusTitle}
                    id={`StatusFilter`}
                    onSelect={(eventKey) => this.handleStatusSelect(eventKey)}
                  >
                    {this.state.statusList ? this.state.statusList.map(status => <MenuItem eventKey={status} key={status.KeyCode}>{status.keyDescription}</MenuItem>) : null}
                  </DropdownButton>

                </Col>
                <Col xs={2}>
                  <form>
                    <FormGroup
                      controlId="formBasicText"
                    >
                      <FormControl
                        onKeyPress={this.onKeyPress}
                        type="text"
                        value={this.state.searchQuery}
                        placeholder="Search..."
                        onChange={this.handleSearchChange}
                      />
                      <FormControl.Feedback />
                    </FormGroup>
                  </form>
                </Col>
              </Row>

              <br/>

              {this.state.filteredResults ?
                  <table className="table table-striped background-white">
                    <thead>
                      <tr>
                        <th scope="col">Case No.</th>
                        <th scope="col">HN</th>
                        <th scope="col">ชื่อ นามสกุล</th>
                        <th scope="col">ประเภทการตรวจ</th>
                        <th scope="col">สถานที่</th>
                        <th scope="col">วันที่ทำการเจาะเลือด</th>
                        <th scope="col">สถานะการตรวจ/การชำระเงิน</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.renderResultRow()}
                    </tbody>
                  </table>
              : <div align='center'>
                  <div className="loader">
                  </div>
                </div>}



            </Grid>
        );
    }

}

export default ResultList;



// WEBPACK FOOTER //
// ./src/components/ResultList.js